import { Injectable, inject } from '@angular/core';
import { Observable } from 'rxjs';
import { ApiService } from './api.service';

export interface ContactFormData {
  name: string;
  email: string;
  message: string;
  recaptchaToken: string;
}

export interface EmailResponse {
  success: boolean;
  message: string;
}

@Injectable({
  providedIn: 'root'
})
export class EmailService {
  private apiService = inject(ApiService);

  /**
   * Invia email di contatto
   */
  sendContactEmail(contactData: ContactFormData): Observable<any> {
    return this.apiService.postFullResponse('/email/contact', contactData);
  }
}
